<template>
  <app-modal
    class="full-width-modal"
    :shown="shown"
    @close="handleClose">
    <div class="center-content-position">
      <div class="modal-header no-padding-left">
        <div class="row">
          <div class="col-xs-10 account-modal">
            <h2 class="modal-title ">Account Details</h2>
            <div>
              <span class="username">
                {{ user.name }}
                <span v-if="internal"> ({{ internal }})</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="container account-modal-container">
        <div class="form-horizontal">
          <div class="form-group">
            <label for="name" class="control-label col-xs-1">Name</label>
            <div class="col-xs-5">
              <span type="text" id="name" class="form-control">
                {{ user.name }}
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="userId" class="control-label col-xs-1">User ID</label>
            <div class="col-xs-5">
              <span type="text" id="userId" class="form-control">
                {{ user.userId }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center-content-position">
      <div class="modal-footer">
        <span class="app-version-number">V {{ version }}</span>
        <button @click="handleClose" class="btn btn-default">Close</button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { mapActions } from 'vuex'
import appModal from 'components/common/app-modal.vue'
import cookies from 'src/services/cookies.service.js'
import packageJson from '../../../../package.json'

export default {
  name: 'modal-details',
  components: {
    appModal,
  },
  props: ['shown'],
  data() {
    return {
      internal: cookies.getCookie('internal'),
      version: packageJson.version,
    }
  },
  computed: {
    user() {
      return this.$store.state.user.currentUser
    },
  },
  methods: {
    ...mapActions({
      hideModal: 'hideModal',
    }),
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.account-modal-container {
  padding-top: 15px;
}
.modal-footer {
  position: relative;
}
.app-version-number {
  top: 30px;
  left: 15px;
  color: #555875;
  font-size: 10px;
  position: absolute;
  font-weight: 500;
  bottom: 45px;
}
.modal-title {
  color: #55a9eb;
}
</style>
